module.exports = __webpack_public_path__ + "static/media/logo_white.f172a465.svg";